import React, { useEffect } from 'react';
import { MessageType } from '../../../../services/actor-messages';
import { WorkspaceManagementContext } from '../../../contexts/workspace/workspace-management-context';
import { useAppSelector } from '../../../hooks/store-hooks';
import { useFlightWorker } from '../../../hooks/use-flight-worker';

export function AirportMonitorStatusUpdates() {
    const context = React.useContext(WorkspaceManagementContext);
    const show = useAppSelector((x) => x.settings.showAirportMonitorStatus);
    const worker = useFlightWorker();

    useEffect(() => {
        worker.actor.registerMessageHandler(MessageType.airportsMonitorStatusSent, async (geoJson) => {
            context.items.forEach((x) => x.airportMonitorStatusLayer.setData(geoJson));
        });
        return () => {
            worker.actor.unregisterMessageHandler(MessageType.airportsMonitorStatusSent);
        };
    }, [context, worker]);

    React.useEffect(() => {
        context.items.forEach((x) => x.airportMonitorStatusLayer.setVisible(show));
        if (show) {
            worker.actor.sendAsync({
                type: MessageType.airportsMonitorStatusEnabledChanged,
                data: show
            });
        }
    }, [show, worker]);

    return null;
}
